import { Waypoints } from "lucide-react";
import { LEVEL_STYLES } from "@/components/hfacs/hfacsLevels";

const PATH_STATUS_STYLES = {
  "Proposé": "bg-slate-100 text-slate-700 border-slate-300",
  "À vérifier": "bg-amber-500/15 text-amber-700 border-amber-500/30",
  "Chemin critique validé": "bg-emerald-500/20 text-emerald-700 border-emerald-500/40 font-semibold",
  "Rejeté": "bg-slate-100 text-slate-500 border-slate-300 line-through opacity-70",
};

export default function MeetingPathsView({ paths, factors }) {
  const factorById = {};
  factors.forEach((f) => { factorById[f.ID_FACTEUR] = f; });

  if (paths.length === 0) {
    return <p className="text-lg text-muted-foreground text-center py-20">Aucun chemin critique pour l'instant.</p>;
  }

  return (
    <div className="max-w-4xl mx-auto space-y-5" data-testid="meeting-paths-view">
      {paths.map((p) => (
        <div key={p.ID_CHEMIN} className="bg-card border border-border rounded-md p-5">
          <div className="flex items-center justify-between gap-3 flex-wrap mb-3">
            <div className="flex items-center gap-2">
              <Waypoints className="h-5 w-5 text-cyan-600" />
              <h4 className="font-heading uppercase text-base font-semibold">{p.NOM_CHEMIN}</h4>
            </div>
            <span className={`font-mono text-xs uppercase px-2.5 py-1 rounded-sm border ${PATH_STATUS_STYLES[p.STATUT] || ""}`}>{p.STATUT}</span>
          </div>
          <div className="flex items-center gap-2 flex-wrap">
            {(p.factor_ids || []).map((fid, idx) => {
              const f = factorById[fid];
              const style = f ? LEVEL_STYLES[f.NIVEAU] : null;
              return (
                <div key={`${p.ID_CHEMIN}-${fid}-${idx}`} className="flex items-center gap-2">
                  <span className={`text-sm px-2.5 py-1.5 rounded-sm border ${style ? style.badge : "bg-secondary text-secondary-foreground border-border"}`}>
                    {f ? (f.JUSTIFICATION || f.FACTEUR) : fid}
                  </span>
                  {idx < p.factor_ids.length - 1 && <span className="text-muted-foreground text-sm">→</span>}
                </div>
              );
            })}
            <span className="text-muted-foreground text-sm">→</span>
            <span className="text-sm px-2.5 py-1.5 rounded-sm border border-orange-500/40 bg-orange-50 text-orange-700">Incident</span>
          </div>
        </div>
      ))}
    </div>
  );
}
